import { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import { Link } from "react-router-dom";
import { X, ArrowRight, Sparkles, TrendingUp, Shield } from "lucide-react";
import EnrichmentModal from "../manchester/EnrichmentModal";

export default function GuaranteedRentClosedModal({ onClose, baseForm }) {
  const [showEnrichment, setShowEnrichment] = useState(false);

  useEffect(() => {
    const prevHtml = document.documentElement.style.overflow;
    const prevBody = document.body.style.overflow;
    document.documentElement.style.overflow = "hidden";
    document.body.style.overflow = "hidden";
    return () => {
      document.documentElement.style.overflow = prevHtml;
      document.body.style.overflow = prevBody;
    };
  }, []);

  if (showEnrichment) {
    return <EnrichmentModal mode="full" baseForm={baseForm} onClose={onClose} onSubmitted={onClose} />;
  }

  return createPortal(
    <div
      style={{ position: "fixed", inset: 0, zIndex: 9999, background: "rgba(0,0,0,0.55)", backdropFilter: "blur(8px)", WebkitBackdropFilter: "blur(8px)", display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
    >
      <div style={{ width: "100%", maxWidth: 480, background: "#fff", borderRadius: 16, overflow: "hidden", boxShadow: "0 24px 80px rgba(0,0,0,0.3)", position: "relative" }}>
        <button
          onClick={onClose}
          style={{ position: "absolute", top: 16, right: 16, background: "#EDE9DC", border: "none", borderRadius: "50%", width: 32, height: 32, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}
        >
          <X size={16} color="#5C7268" />
        </button>

        <div style={{ padding: "44px 32px 32px", textAlign: "center" }}>
          <div style={{ width: 56, height: 56, borderRadius: 14, background: "#F4F1E7", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 22px" }}>
            <Sparkles size={26} color="#CD533B" />
          </div>

          <h2 style={{ fontFamily: "'Inter', sans-serif", fontWeight: 700, fontSize: 24, color: "#112215", margin: "0 0 12px", letterSpacing: "-0.01em", lineHeight: 1.25 }}>
            Guaranteed rent is currently closed
          </h2>
          <p style={{ fontFamily: "'Inter', sans-serif", fontSize: 15, color: "#5C7268", lineHeight: 1.65, margin: "0 0 24px" }}>
            We're not taking on new guaranteed rent agreements right now. However, we'd be delighted to explore <strong style={{ color: "#112215" }}>Airbnb management</strong> with you instead — it's entirely hassle-free, and you'll typically earn more overall.
          </p>

          <div style={{ display: "flex", flexDirection: "column", gap: 10, textAlign: "left", marginBottom: 28 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 12, background: "#F4F1E7", borderRadius: 10, padding: "12px 14px" }}>
              <div style={{ width: 34, height: 34, borderRadius: 9, background: "#fff", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                <Shield size={16} color="#CD533B" />
              </div>
              <span style={{ fontFamily: "'Inter', sans-serif", fontSize: 13.5, color: "#5C7268", lineHeight: 1.5 }}>Fully managed — we handle everything end to end</span>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 12, background: "#F4F1E7", borderRadius: 10, padding: "12px 14px" }}>
              <div style={{ width: 34, height: 34, borderRadius: 9, background: "#fff", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                <TrendingUp size={16} color="#CD533B" />
              </div>
              <span style={{ fontFamily: "'Inter', sans-serif", fontSize: 13.5, color: "#5C7268", lineHeight: 1.5 }}>Earn 40–80% more than a standard long let</span>
            </div>
          </div>

          <button
            onClick={() => setShowEnrichment(true)}
            style={{ width: "100%", background: "#112215", color: "#fff", border: "none", borderRadius: 10, padding: "15px", fontFamily: "'Inter', sans-serif", fontSize: 15, fontWeight: 700, cursor: "pointer", transition: "background 0.2s", display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 8, marginBottom: 10 }}
            onMouseEnter={(e) => (e.currentTarget.style.background = "#1A3A2A")}
            onMouseLeave={(e) => (e.currentTarget.style.background = "#112215")}
          >
            Get Management Estimates <ArrowRight size={16} />
          </button>
          <Link
            to="/"
            onClick={onClose}
            style={{ display: "inline-block", fontFamily: "'Inter', sans-serif", fontSize: 14, fontWeight: 500, color: "#112215", textDecoration: "underline", marginBottom: 10 }}
          >
            Learn more about Airbnb management
          </Link>
          <button
            onClick={onClose}
            style={{ background: "none", border: "none", color: "#8A9B92", fontFamily: "'Inter', sans-serif", fontSize: 14, cursor: "pointer", padding: "6px" }}
          >
            No thanks
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}